module.exports = __webpack_public_path__ + "img/summary_3.49cfe64a.png";